<template>
  <div class="energy-center-box">
    <img
      v-show="showindex == 1"
      class="imgcenter"
      src="@/assets/images/energyStorage/centerImg1.png"
      alt=""
    />
    <img
      v-show="showindex == 2"
      class="imgcenter"
      src="@/assets/images/energyStorage/centerImg2.png"
      alt=""
    />
    <img
      v-show="showindex == 3"
      class="imgcenter"
      src="@/assets/images/energyStorage/centerImg3.png"
      alt=""
    />
    <img
      v-show="showindex == 4"
      class="imgcenter"
      src="@/assets/images/energyStorage/centerImg4.png"
      alt=""
    />
    <target></target>

    <div class="info-box">
      <div class="title">PCS:<span style="margin-left:10px">{{pcsObj.pcs_devno}}</span></div>
      <div class="boxcell">
        <div class="left">PCS运行状态</div>
        <div class="right">{{ pcsinfoObj.pcs_run_status }}</div>
      </div>
      <div class="boxcell">
        <div class="left">电压(V)</div>
        <div class="right ycolor">{{ pcsinfoObj.vol }}</div>
      </div>
      <div class="boxcell">
        <div class="left">电流(A)</div>
        <div class="right ycolor">{{ pcsinfoObj.cur }}</div>
      </div>
      <div class="boxcell">
        <div class="left">功率(kw)</div>
        <div class="right ycolor">{{ pcsinfoObj.pow }}</div>
      </div>
    </div>

    <div class="info-main-box">
      <div class="title" style="padding-left:10px">{{arrObj.arr_name}}储能单元</div>
      <div class="sub-title">
        <div class="cell-box">
          充电功率：<span class="number">{{ infoObj.arrmaxrechapower }}</span>
          <span class="unit">KW </span>
        </div>
        <div class="cell-box">
          可充电量：<span class="number">{{ infoObj.arrrechaelec }}</span>
          <span class="unit">kWS </span>
        </div>
        <div class="cell-box">
          上限：<span class="number">{{ infoObj.clumaxsoc }}</span>
          <span class="unit">% </span>
        </div>
        <div class="cell-box">
          放电功率：<span class="number">{{
            infoObj.arrmaxredischgpower
          }}</span>
          <span class="unit">KW </span>
        </div>
        <div class="cell-box">
          可放电量：<span class="number">{{ infoObj.arrredischgelec }}</span>
          <span class="unit">kWS </span>
        </div>
        <div class="cell-box">
          下限：<span class="number">{{ infoObj.cluminsoc }}</span>
          <span class="unit">% </span>
        </div>
      </div>
      <div class="list-box">
        <dv-scroll-board :config="config" class="newTable" />
      </div>
    </div>
  </div>
</template>

<script>
import target from "@/views/components/energyStorage/target.vue";
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  components: {
    target,
  },
  data() {
    return {
      showindex: 1,
      config: {
        headerBGC: "rgba(53, 149, 147, 0.2)",
        headerHeight: 50,
        carousel: "single",
        hoverPause: true,
        oddRowBGC: "rgba(53, 149, 147, 0)",
        evenRowBGC: "rgba(53, 149, 147, 0)",
        rowNum: 4, //表格行数
        header: [
          "序号",
          "簇号",
          "SOC",
          "SOH",
          "累计充电量",
          "累计放电量",
          "运行状态",
        ],
        data: [],
      },
      infoObj: {},
      pcsinfoObj: {},
      arrObj: {},
      pcsObj:{}
    };
  },
  mounted() {
    // setInterval(()=>{
    // 	this.showindex++
    // 	if(this.showindex >4) {
    // 		this.showindex = 1
    // 	}
    // },3000)
    this.$bus.$on("onfangdiangonglv", () => {
      this.getlidianziliebiao();
    });
    this.getlidianziliebiao();
  },
  methods: {
    getlidianziliebiao() {
      let _this = this;
      let params = {
        enCode: "chuneng-quanguo-llzcndy",
        "@energyId": "ES00001",
        "@arr_num": 0,
      };
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if (!res || !res.length) return;
          this.infoObj = res[0];
        })
        .catch((err) => {
          console.log(err, "error");
        });

      // 获取列表
      let params1 = {
        enCode: "chuneng-quanguo-cdtxx",
        "@energyId": "ES00001",
        "@arr_num": 0,
      };
      dataInterface
        .dataFaceApi(params1)
        .then((res) => {
          if (!res || !res.length) return;
          let newList = [];
          res.map((item, index) => {
            newList.push([
              index,
              item.clu_num,
              item.soc,
              item.soh,
              item.acc_charge_elect,
              item.acc_discharge_elect,
              item.clu_status,
            ]);
          });
          this.config = {
            headerBGC: "rgba(53, 149, 147, 0.2)",
            headerHeight: 60,
            carousel: "single",
            hoverPause: true,
            oddRowBGC: "rgba(53, 149, 147, 0.2)",
            evenRowBGC: "rgba(53, 149, 147, 0)",
            rowNum: 4, //表格行数
            header: [
              "序号",
              "簇号",
              "SOC",
              "SOH",
              "累计充电量",
              "累计放电量",
              "运行状态",
            ],
            data: newList,
          };
          // console.log(newList, "999999999999999");
        })
        .catch((err) => {
          console.log(err, "error");
        });

      let params2 = {
        enCode: "chuneng-quanguo-pcsinformation",
        "@energyId": "ES00001",
        "@arr_num": 0,
      };
      // 获取PCS信息
      dataInterface
        .dataFaceApi(params2)
        .then((res) => {
          if (!res || !res.length) return;
          this.pcsinfoObj = res[0];
          console.log(this.pcsinfoObj,'this.pcsinfoObj')
        })
        .catch((err) => {
          console.log(err, "error");
        });
      // 电池堆
      let params3 = {
        enCode: "chuneng-quanguo-cndyjk",
        "@energyId": "ES00001",
      };
      dataInterface
        .dataFaceApi(params3)
        .then((res) => {
          if (!res || !res.length) return;
          console.log(res, "PCS变流器监控");
          this.arrObj = res[0];
        })
        .catch((err) => {
          console.log(err, "error");
        });
          // 电池堆
      let params4 = {
        enCode: "chuneng-quanguo-pcsblqjk",
        "@energyId": "ES00001",
      };
      dataInterface
        .dataFaceApi(params4)
        .then((res) => {
          if (!res || !res.length) return;
          console.log(res, "PCS变流器监控");
          this.pcsObj = res[0];
        })
        .catch((err) => {
          console.log(err, "error");
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/views/components/energyStorage/comm.scss";
.energy-center-box {
  width: 1440px;
  height: 1470px;
  margin-top: 100px;
  position: relative;
  .imgcenter {
    width: 1210px;
    height: 750px;
    position: absolute;
    left: 50%;
    margin-left: -605px;
    top: 50%;
    margin-top: -420px;
  }
  .info-box {
    position: absolute;
    right: 76px;
    top: 290px;
    width: 321px;
    background: rgba(0, 15, 31, 0.8);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    border: 1px solid rgba(53, 250, 254, 0.4);
    padding: 15px 15px 5px 15px;
    .title {
      letter-spacing: 2px;
      width: 297px;
      line-height: 50px;
      padding-left: 8px;
      // font-weight: 600;
      background: linear-gradient(
        90deg,
        #35fbfe -140%,
        rgba(53, 251, 254, 0) 100%
      );
      border-radius: 0px 0px 0px 0px;
      font-size: 32px;
      opacity: 1;
      font-family: "PMZD";
      margin-bottom:10px ;
    }
    .boxcell {
      line-height: 35px;
      display: flex;
      justify-content: space-between;
      padding: 5px 10px;
      font-size: 20px;
      .right {
        text-align: right;
        
        font-family: "PMZD";
      }
      .left{

      }
      .ycolor {
        color: #ffd15c;
        // font-weight: 600;
      }
    }
  }
  .info-main-box {
    position: absolute;
    left: 10px;
    bottom: 250px;
    width: 900px;
    height: 410px;
    background: rgba(0, 15, 31, 0.8);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    border: 1px solid rgba(53, 250, 254, 0.4);
    padding: 15px;
    .title {
      width: 821px;
      line-height: 50px;
      padding-left: 8px;
      font-size: 32px;
      // font-weight: 600;
      letter-spacing: 2px;
      background: linear-gradient(
        90deg,
        #35fbfe -140%,
        rgba(53, 251, 254, 0) 100%
      );
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      font-family: "PMZD";
    }
    .sub-title {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 20px;
      font-size: 22px;
      .cell-box {
        padding-top: 10px;
        width: 287px;
        height: 30px;
        line-height: 30px;
        .number {
          color: #31c6c9;
          font-size: 20px;
          // font-weight: 600;
          font-family: "PMZD";
          letter-spacing: 2px;
        }
        .unit {
          color: #31c6c9;
          margin-left: 3px;
          font-family: "PMZD";
        }
      }
      .cell-box:nth-child(3) {
        padding-left: 70px;
      }
      .cell-box:nth-child(6) {
        padding-left: 70px;
      }
    }
    .list-box {
      height: 250px;
    }
  }
  .dv-scroll-board ::v-deep .header {
    font-size: $FontSize20;
  }
  .dv-scroll-board ::v-deep .rows .row-item {
    font-size: $FontSize20;
  }
}
</style>